import { lazy } from 'react';

const EmployerQuestionModal = lazy(() =>
  import('../OrgProfile/components/EmployerQuestionModal'),
);

export default {
  EMPLOYER_QUESTION_MODAL: EmployerQuestionModal,
};
